import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IAirTransport, IAirTransportResponse, IPaymentGroups } from "./IAirTransport";

export const airTransportApi = createApi({
  reducerPath: "airTransport",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.AIRTRANSPORT,
  }),
  tagTypes: ["air-transport", "air-unit"],
  endpoints: (builder) => ({
    getFilteredTransport: builder.query<IAirTransportResponse, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["air-transport"],
    }),
    getAllTransport: builder.query<(IAirTransport & IPaymentGroups)[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["air-transport"],
    }),
    addUnit: builder.mutation<any, Omit<(IAirTransport & IPaymentGroups), "id">>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["air-transport"],
    }),
    getUnit: builder.query<IAirTransport & IPaymentGroups, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["air-unit"],
    }),
    editUnit: builder.mutation<(IAirTransport & IPaymentGroups), ( IAirTransport & IPaymentGroups)>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["air-transport", "air-unit"],
    }),
    deleteUnit: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["air-transport"],
    }),
  }),
});

export const {
  useAddUnitMutation,
  useDeleteUnitMutation,
  useGetAllTransportQuery,
  useGetFilteredTransportQuery,
  useEditUnitMutation,
  useGetUnitQuery
} = airTransportApi;
